import React from "react";

const YourDreamOne = () => {
  return (
    <section className="your-dream-one section-space">
      <div className="container">
        <div className="row gutter-y-40">

          {/* Left Image Section */}
          <div className="col-lg-6">
            <div
              className="your-dream-one__thumb wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="500ms"
            >
              <div className="your-dream-one__thumb__item">
                <img
                  src="/images/urbania.png"
                  alt="Aaradhya Travels Driver"
                />
              </div>

              <div className="your-dream-one__thumb__item-small">
                <img
                  src="/images/fleets/17-Seater-Tempo-Traveller.jpg"
                  // src="/images/about/our-driver-1-2.jpg"
                  alt="Travel Service"
                />
              </div>
            </div>
          </div>

          {/* Right Content Section */}
          <div className="col-lg-6">
            <div className="your-dream-one__container">

              {/* Section Title */}
              <div className="sec-title sec-title--two text-start">
                <h6 className="sec-title__tagline bw-split-in-right">
                  AARADHYA TRAVELS
                </h6>

                <h3 className="sec-title__title bw-split-in-left">
                  SAFE, COMFORTABLE & RELIABLE TRAVEL EXPERIENCE
                </h3>
              </div>

              {/* Text */}
              <p
                className="your-dream-one__text wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="500ms"
              >
                Aaradhya Travels provides trusted cab and travel services
                with professional drivers, clean vehicles, and affordable
                pricing. We ensure comfortable journeys for local trips,
                outstation travel, airport transfers, and family tours
                with complete customer satisfaction and reliable support.
              </p>

              {/* Fun Facts */}
              <div className="your-dream-one__funfact">
                <div className="row gutter-y-30">

                  {/* Fun Fact 1 */}
                  <div
                    className="col-md-6 col-sm-12 wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="500ms"
                  >
                    <div className="funfact-one__item count-box">
                      <div
                        className="funfact-one__item__bg"
                        style={{
                          backgroundImage:
                            "url(/images/resources/funfact-bg-1-1.jpg)",
                        }}
                      ></div>

                      <h3 className="funfact-one__funfact__count">
                        <span
                          className="count-text"
                          data-stop="500"
                          data-speed="1500"
                        >
                          4000
                        </span>
                        <span>+</span>
                      </h3>

                      <p className="funfact-one__funfact__text">
                        Happy Customers
                      </p>

                      <div className="funfact-one__border__group">
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>

                  {/* Fun Fact 2 */}
                  <div
                    className="col-md-6 col-sm-12 wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="500ms"
                  >
                    <div className="funfact-one__item count-box">
                      <div
                        className="funfact-one__item__bg"
                        style={{
                          backgroundImage:
                            "url(/images/resources/funfact-bg-1-2.jpg)",
                        }}
                      ></div>

                      <h3 className="funfact-one__funfact__count">
                        <span
                          className="count-text"
                          data-stop="50"
                          data-speed="1500"
                        >
                          50
                        </span>
                        <span>K+</span>
                      </h3>

                      <p className="funfact-one__funfact__text">
                        Kilometers Covered
                      </p>

                      <div className="funfact-one__border__group">
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>

                  {/* Fun Fact 3 */}
                  <div
                    className="col-md-6 col-sm-12 wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="500ms"
                  >
                    <div className="funfact-one__item count-box">
                      <div
                        className="funfact-one__item__bg"
                        style={{
                          backgroundImage:
                            "url(/images/resources/funfact-bg-1-3.jpg)",
                        }}
                      ></div>

                      <h3 className="funfact-one__funfact__count">
                        <span
                          className="count-text"
                          data-stop="100"
                          data-speed="1500"
                        >
                          400
                        </span>
                        <span>+</span>
                      </h3>

                      <p className="funfact-one__funfact__text">
                        Pickup & Drop Trips
                      </p>

                      <div className="funfact-one__border__group">
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>

                  {/* Fun Fact 4 */}
                  <div
                    className="col-md-6 col-sm-12 wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay="500ms"
                  >
                    <div className="funfact-one__item count-box">
                      <div
                        className="funfact-one__item__bg"
                        style={{
                          backgroundImage:
                            "url(/images/resources/funfact-bg-1-4.jpg)",
                        }}
                      ></div>

                      <h3 className="funfact-one__funfact__count">
                        <span
                          className="count-text"
                          data-stop="24"
                          data-speed="1500"
                        >
                          24
                        </span>
                        <span>/7</span>
                      </h3>

                      <p className="funfact-one__funfact__text">
                        Customer Support
                      </p>

                      <div className="funfact-one__border__group">
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      {/* Decorative Elements */}
      <div className="your-dream-one__element-two">
        <img
          src="/images/shapes/truse-1-1.png"
          alt="Shape Two"
        />
      </div>

      <div className="your-dream-one__element-three">
        <img
          src="/images/shapes/truse-1-2.png"
          alt="Shape Three"
        />
      </div>

    </section>
  );
};

export default YourDreamOne;